import { DividerDashed } from '../layout/DividerDashed';

interface PillarLabelProps {
  number: '01' | '02' | '03';
  label: string;
  centered?: boolean;
}

/**
 * Numbered label ([01], [02], [03]) centered between dashed lines.
 * Used to introduce major sections/pillars of the product.
 */
export function PillarLabel({ number, label, centered = false }: PillarLabelProps) {
  return (
    <div className="w-full">
      <DividerDashed intensity="medium" />
      <div className={`flex py-4 ${centered ? 'justify-center' : 'justify-start'}`}>
        <span className="text-label text-accent font-medium">
          [{number}] {label}
        </span>
      </div>
      <DividerDashed intensity="medium" />
    </div>
  );
}
